var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Einstellungen")]),_c('LieutenantComp',{attrs:{"raid":_vm.raid,"disabled":!_vm.isRaidLead}}),(_vm.isRaidLead)?_c('LogUploadComp',{staticClass:"marginTop",attrs:{"raid":_vm.raid}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }